import {
  UseFormRegister,
  FieldErrors,
  RegisterOptions,
  Path,
  FieldValues,
} from 'react-hook-form';

interface CustomInputProps<T extends FieldValues> {
  name: Path<T>;
  label?: string;
  placeholder?: string;
  type?: string;
  register: UseFormRegister<T>;
  rules?: RegisterOptions<T, Path<T>>;
  errors?: FieldErrors<T>;
  className?: string;
  defaultValue?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void; // ✅ allow external change handling (e.g., Zustand)
}

const CustomInput = <T extends FieldValues>({
  name,
  placeholder,
  type = 'text',
  register,
  rules,
  errors,
  className = '',
  defaultValue,
  onChange,
}: CustomInputProps<T>) => {
  const { onChange: registerOnChange, ...registerRest } = register(name, rules);

  return (
    <div className='form-control w-full mb-2'>
      <input
        type={type}
        {...registerRest}
        onChange={e => {
          registerOnChange(e); // First trigger react-hook-form's change
          if (onChange) onChange(e); // Then trigger external change if provided
        }}
        className={`rounded-lg input input-bordered input-secondary w-full text-sm h-full pb-2 pt-3 pl-4 placeholder:font-normal ${className}`}
        placeholder={placeholder}
        defaultValue={defaultValue}
      />
      {errors?.[name] && (
        <label className='label pt-1 pb-0'>
          <span className='label-text-alt text-error'>
            {errors[name]?.message as string}
          </span>
        </label>
      )}
    </div>
  );
};

export default CustomInput;
